var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input-number',{attrs:{"dense":_vm.dense,"label":_vm.label,"value":_vm.val,"required":_vm.inputField.isRequired,"suffix":_vm.inputField.suffix,"hint":_vm.inputField.hint},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }